import { Badge, Box, Group, Stack, Text } from '@mantine/core';
import { useState } from 'react';
import { DOSESPOT_PREVIEW_IMAGE_PATH } from '../../clients/components/dosespotTypes';

export function PrescribeTab(): JSX.Element {
  const [previewLoadFailed, setPreviewLoadFailed] = useState(false);

  return (
    <Stack gap="sm">
      <Group gap="xs" align="center">
        <Text size="sm" fw={600}>
          E-Prescribe
        </Text>
        <Badge variant="light" color="gray" size="sm">
          DOSESPOT
        </Badge>
      </Group>
      <Text size="xs" c="dimmed">
        Embedded DoseSpot prescribing will appear here during telehealth sessions.
      </Text>
      <Box
        style={{
          borderRadius: 'var(--mantine-radius-sm)',
          overflow: 'hidden',
          border: previewLoadFailed
            ? '1px dashed var(--mantine-color-gray-4)'
            : '1px solid var(--mantine-color-gray-3)',
          backgroundColor: 'var(--mantine-color-gray-0)',
          minHeight: 320,
        }}
      >
        {previewLoadFailed ? (
          <Stack align="center" justify="center" gap="xs" p="xl" mih={320}>
            <Text size="sm" fw={500} ta="center">
              DoseSpot preview unavailable
            </Text>
            <Text size="xs" c="dimmed" ta="center">
              Add the mock image at medplum-ui/public/integrations/dosespot-mock.png
            </Text>
          </Stack>
        ) : (
          <img
            src={DOSESPOT_PREVIEW_IMAGE_PATH}
            alt="DoseSpot e-prescribing integration preview"
            onError={() => setPreviewLoadFailed(true)}
            style={{
              display: 'block',
              width: '100%',
              height: 'auto',
            }}
          />
        )}
      </Box>
      <Text size="xs" c="dimmed">
        Static UI preview — live DoseSpot embed pending.
      </Text>
    </Stack>
  );
}
